<footer class="footer-wrapper">
  <div>
    &copy; Dancekids Studio {{ year }}
    <br />
    <span class="watermark">(v.{{ version }})</span>
    <a [routerLink]="['/privacy']">Privacy Policy</a>
  </div>
  <div class="no-small social">
    <a href="https://www.facebook.com/DancekidsStudioLebanon/">
      <img
        class="filter-primary"
        src="./../../../../assets/images/stock/square-facebook-brands.svg"
        alt="facebook" />
    </a>
    <a href="https://www.instagram.com/dancekidsstudio/" target="_blank">
      <img
        class="filter-primary"
        src="./../../../assets/images/stock/square-instagram-brands.svg"
        alt="instagram" />
    </a>
    <a href="https://www.youtube.com/@DancekidsStudio" target="_blank">
      <img
        class="filter-primary"
        src="./../../../assets/images/stock/youtube-brands.svg"
        alt="youtube" />
    </a>
  </div>
  <div>
    <a href="tel:+15134095514">(513) 409-5514</a>
    <a
      href="https://goo.gl/maps/hLYd9HAWmV2HxtPa9"
      target="_blank"
      title="Open In Google Maps">
      <address>
        726 E. Main St.
        <br />
        Lebanon, OH 45036
      </address>
    </a>
    <img
      class="none"
      src="./../../../assets/images/logos/dks-dancer-square.png"
      alt="logo" />
    <img
      class="none"
      src="./../../../assets/icons/favicon-32x32.png"
      alt="logo" />
  </div>
</footer>
